import React, { createContext, useCallback, useEffect, useState } from 'react'

export const LocaleContext = createContext()

export const langList = [
  { key: 'en', value: 'en', default: true },
  { key: 'es', value: 'es', default: false }
]

const LocaleProvider = ({ location, children }) => {
  const [lang, setLanguage] = useState('en')
  const localeText = require(`../data/text.${lang}.json`)

  const setLang = useCallback((name) => {
    setLanguage(name)
  }, [])

  const getI18Url = (to) => {
    const urlLang = location.pathname.split('/')[1]

    const l = langList.find((l) => urlLang === l.key)

    return l && l.key ? `/${urlLang}${to}` : to
  }

  useEffect(() => {
    const urlLang = location.pathname.split('/')[1]
    // console.dir(urlLang)
    if (urlLang === '') setLang('en')

    const l = langList.find((l) => urlLang === l.key)
    if (l && l.key) setLang(l.key)
    // console.dir(l)
  }, [location])

  return (
    <LocaleContext.Provider
      value={{
        lang,
        setLang,
        getI18Url,
        localeText
      }}
    >
      {children}
    </LocaleContext.Provider>
  )
}

export default LocaleProvider
